import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

// OData API Giriş İstek Fonksiyonu
const loginApi = async (email, password) => {
  // NOT: OData $filter ile GET isteği atarak kullanıcı doğruluyoruz.
  const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Users?$filter=Users_Email eq '${email}' and Users_Password eq '${password}'`);
  if (!response.ok) {
    throw new Error("Sunucuya ulaşılamadı.");
  }
  return await response.json();
};

// authSaga.js içindeki loginUser jeneratör fonksiyonu
function* loginUser({ payload: { user, history } }) {
  try {
    const data = yield call(loginApi, user.email, user.password);

    if (data && data.value && data.value.length > 0) {
      const loggedInUser = data.value[0]; 
      
      // Kullanıcı bilgisini ve tipini kaydediyoruz
      // Örn: loggedInUser.Users_Type_ID === 1 ise Admin
      localStorage.setItem("authUser", JSON.stringify(loggedInUser));
      
      yield put(loginSuccess(loggedInUser));
      
      // Başarılı girişte yönlendirme
      history('/dashboard'); 
    } else {
      yield put(apiError("Geçersiz e-posta veya şifre girdiniz."));
    }
  } catch (error) {
    yield put(apiError(error.message || "Giriş hatası."));
  }
}
function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess());
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

// Social Login şimdilik devre dışı bırakılabilir veya kendi backendinize uyarlanabilir
function* socialLogin({ payload: { type, history } }) {
  try {
    yield put(apiError("Sosyal giriş şu anda desteklenmemektedir."));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;